module.exports = __webpack_public_path__ + "img/scop1.c51cd94e.jpg";